module.exports = __webpack_public_path__ + "img/first-step.5d346595.png";